export const EDIT_FORGOT_PASSWORD = 'forgotPassword/EDIT_FORGOT_PASSWORD'
export const UPDATE_MESSAGE = 'forgotPassword/UPDATE_MESSAGE'